import React, { useState, useEffect } from 'react';
import { format, subYears }       from 'date-fns';
import DateSelector from './DateSelector';
import BarChartRow from './BarChartRow';

const BarGraphWidget = ({dateRanges, isChannelDashboard, queryParams, path, defaultDashboard, color, channelName}) => {

  const initialRangeIndex = isChannelDashboard ? 4 : 0;
  const [selectedRange, setSelectedRange] = useState(dateRanges[initialRangeIndex].label);
  const [from, setFrom] = useState(dateRanges[initialRangeIndex].from);
  const [to, setTo] = useState(dateRanges[initialRangeIndex].to);
  const [channelData, setChannelData] = useState([]);
  const [allChannelsData, setAllChannelsData] = useState([]);
  const [head, setHead] = useState(null);

  useEffect(() => {
    markSafariLegacy();
    fetchAllChannelsStats();
    fetchSpecificChannelStats(from, to, selectedRange);
  }, []);

  const fetchSpecificChannelStats = (fromDate, toDate, selectedRange) => {
    setFrom(fromDate);
    setTo(toDate);
    setSelectedRange(selectedRange);
    getStats(setChannelData, false, fromDate, toDate, selectedRange);
  }

  const fetchAllChannelsStats = () => {
    const today     = format(new Date(), 'yyyy-MM-dd');
    const oneYearAgo= format(subYears(new Date(), 1), 'yyyy-MM-dd');
    getStats(setAllChannelsData, true, oneYearAgo, today);
  }
  
  const markSafariLegacy = () => {
    const ua = navigator.userAgent;
    // make sure it’s Safari, not Chrome/Edge/etc
    if (!/Safari/.test(ua) || /Chrome/.test(ua) || /Chromium/.test(ua)) {
      return;
    }
    // grab the Version/x.y part
    const m = ua.match(/Version\/(\d+)\.(\d+)/);
    if (!m) return;
    const major = parseInt(m[1], 10);
    if (major < 18) {
      document.documentElement.classList.add('safari-legacy');
    }
  }

  const getStats = (setter, allChannels, fromDate, toDate, selectedRange=null) => {
    setter([]);
    Object.keys(queryParams).forEach((label) => {
      let position = queryParams[label];
      setFrom(fromDate);
      setTo(toDate);
      setSelectedRange(selectedRange);
      $.ajax({
        type: 'get',
        url: path,
        data: { from: fromDate, to: toDate, default_dashboard: defaultDashboard, label: label , position: position, line_items: true, ...(allChannels ? {allChannels: true} : {})},
        success: function (res) {
          setter(prevData => {
            const newSortedchannelData = [...prevData, res.channelData].sort((a, b) => a.position - b.position);
            return newSortedchannelData;
          });
          
          setHead(res.head);
        },
        error: function (e) {
          console.error(e);
        }
      });
    });
  };

  const renderHeader = () => {
    if (!head) return null;
    return (
      <div style={{display: 'flex'}}>
        <h6><i className={head.icon} />{head.title}</h6>
      </div>
    );
  };

  const chartRows = [
    { name: channelName, data: channelData },
    { name: 'All Academic Channels',    data: allChannelsData }
  ];
  const chartWidth = 800;
  const tickStep   = 5;
  const totals = chartRows.map(r => r.data.reduce((sum, seg) => sum + parseFloat(seg.total), 0));
  const globalMax = Math.max(...totals);
  const maxDisplay = Math.ceil(globalMax / tickStep) * tickStep;
  const pxPerDay = chartWidth / maxDisplay;
  const ticks = Array.from({ length: maxDisplay / tickStep + 1 }, (_, i) => i * tickStep);

  return (
    <div className='row'>
      <div className='large-12 columns'>
        <div className='dashboard-published-content-wrap time-to-publish' style={{ backgroundColor: color }}>
          <div className='row'>
            <div className='large-10 columns'>
              <div className='published-content-stats-wrap'>
                {renderHeader()}
              </div>
            </div>
            <div className='large-2 columns'>
              <DateSelector
                from={from}
                to={to}
                getStats={fetchSpecificChannelStats}
                selectedRange={selectedRange}
                dateRanges={dateRanges}
              />
            </div>
          </div>
          {channelData && (
            <div>
              <div className='row'>
                <div className='large-12 columns bar-chart-section'>
                  <div className="bar-chart-widget">


                    {chartRows.map((row, idx) => (
                      <BarChartRow
                        key={row.name}
                        name={row.name}
                        data={row.data}
                        chartWidth={chartWidth}
                        pxPerDay={pxPerDay}
                      />
                    ))}

                    <div className="x-axis">
                      {ticks.map(x => (
                        <span key={x}>{x}</span>
                      ))}
                    </div>

                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='large-12 columns'>
                  <div className="keys-section">
                    {allChannelsData.map((el) => {
                      return (
                        <div className="keys-container">
                          <div className="color-box" style={{background: `${el.color}`}} />
                          <span className="key">{el.label}</span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>

              {/* Greg or Nina might add a copy in this section in the future */}
              {/* <div className="caveat">
                <i>*Updated every month</i>
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BarGraphWidget;
